import { FilterPersistenceResponse, UserFilter } from './Types';

export const FILTER_SAVED_SUCCESS_MSG = 'filter was saved';
export const FILTER_DELETED_SUCCESS_MSG = 'filter was deleted';
export const FILTER_ID_NOT_FOUND = 'No filter with this id was found';
export const FILTERS_LOADING_ERROR_MSG = 'There has been an error loading saved filters.';
export const FILTER_SAVE_ERROR_MSG = 'There has been an error while saving filter';
export const FILTER_DELETE_ERROR_MSG = 'Filter has not been removed due to error';
export const FILTER_SAVE_NAME_ERROR_MSG = 'Please provide a unique filter name to proceed';

export const createFilterSavedSuccessfullyResponse: (filter: UserFilter) => FilterPersistenceResponse = (filter) => {
  return {
    message: `${filter.name} ${FILTER_SAVED_SUCCESS_MSG}`,
    status: 'SUCCESS',
    filter,
  };
};

export const createFilterDeletedSuccessfullyResponse: (filterName: string) => FilterPersistenceResponse = (name) => {
  return {
    message: `${name} ${FILTER_DELETED_SUCCESS_MSG}`,
    status: 'SUCCESS',
  };
};

export const createFilterIdNotFoundResponse: (id: string) => FilterPersistenceResponse = (id) => {
  return {
    message: `${FILTER_ID_NOT_FOUND} (${id})`,
    status: 'ERROR',
  };
};

export const createFiltersCouldNotBeLoadedResponse: () => FilterPersistenceResponse = () => {
  return {
    message: FILTERS_LOADING_ERROR_MSG,
    status: 'ERROR',
  };
};

export const createFilterCouldNotBeSavedResponse: (filterName: string) => FilterPersistenceResponse = (filterName) => {
  return {
    message: `${FILTER_SAVE_ERROR_MSG} ${filterName}`,
    status: 'ERROR',
  };
};

export const createFilterCouldNotBeSavedWithNameResponse: () => FilterPersistenceResponse = () => {
  return {
    message: FILTER_SAVE_NAME_ERROR_MSG,
    status: 'VALIDATION_ERROR',
  };
};

export const createFilterCouldNotBeDeletedResponse: () => FilterPersistenceResponse = () => {
  return {
    message: FILTER_DELETE_ERROR_MSG,
    status: 'ERROR',
  };
};
